window.ENV ={
    "RECAPTCHA_SITE": "6LdV9PYfAAAAALZQKOa84KQkK2KTGpiTSUOVrIqQ"
}
